"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLICATION_FORM_ENCODED = exports.X_FORWARDED_PORT = exports.X_FORWARDED_FOR = exports.XML_CSRF_TOKEN = exports.XML_HTTP_REQUEST_WITH = exports.XML_HTTP_REQUEST = exports.USER_DELEGATION_ID = exports.USER_ID = exports.CONTENT_TYPE_VALUE_HEADER = exports.CONTENT_TYPE_HEADER = exports.SECURITY_POLICY_HEADER = void 0;
exports.SECURITY_POLICY_HEADER = 'Content-Security-Policy';
exports.CONTENT_TYPE_HEADER = 'Content-Type';
exports.CONTENT_TYPE_VALUE_HEADER = 'application/json;charset=UTF-8';
exports.USER_ID = 'userId';
exports.USER_DELEGATION_ID = 'userDelegationId';
exports.XML_HTTP_REQUEST = 'XMLHttpRequest';
exports.XML_HTTP_REQUEST_WITH = 'X-Requested-With';
exports.XML_CSRF_TOKEN = 'X-CSRF-TOKEN';
exports.X_FORWARDED_FOR = 'x-forwarded-for';
exports.X_FORWARDED_PORT = 'x-forwarded-port';
exports.APPLICATION_FORM_ENCODED = 'application/x-www-form-urlencoded';
